import { z } from 'zod';
export const loadingSlideRouteLocationSchema = z.object({
    iataCode: z.string().min(1),
    label: z.string().min(1),
});
export const createLoadingSlideSchema = z.object({
    bodyImage: z.string().min(1),
    destinations: z.array(loadingSlideRouteLocationSchema).optional(),
    footerText: z.string().min(1),
    headerText: z.string().min(1),
    isDefault: z.boolean().optional(),
    origins: z.array(loadingSlideRouteLocationSchema).optional(),
});
export const updateLoadingSlideSchema = z.object({
    bodyImage: z.string().min(1).optional(),
    destinations: z.array(loadingSlideRouteLocationSchema).optional(),
    footerText: z.string().min(1).optional(),
    headerText: z.string().min(1).optional(),
    isActive: z.boolean().optional(),
    isDefault: z.boolean().optional(),
    origins: z.array(loadingSlideRouteLocationSchema).optional(),
});
